import type { UI } from '@/v2/types';
import { useMemo } from 'react';
import buildThemeSearchConfig from './buildThemeSearchConfig';

export type UseEnrichThemeDestinationProps = {
  destinationOrTheme: UI.Destination | null;
  properties: UI.Property[] | null;
};

const useEnrichThemeDestination = ({
  destinationOrTheme,
  properties,
}: UseEnrichThemeDestinationProps) => {
  return useMemo(() => {
    if (!destinationOrTheme || !destinationOrTheme?.theme || !properties)
      return destinationOrTheme;

    return {
      ...destinationOrTheme,
      ...buildThemeSearchConfig({
        properties: properties,
      }),
    };
  }, [destinationOrTheme, properties]);
};

export default useEnrichThemeDestination;
